import { render, staticRenderFns } from "./IntraoralArchPanel.vue?vue&type=template&id=7960b19c&scoped=true&"
import script from "./IntraoralArchPanel.vue?vue&type=script&lang=js&"
export * from "./IntraoralArchPanel.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralArchPanel.vue?vue&type=style&index=0&id=7960b19c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960b19c",
  null
  
)

export default component.exports